<template>
  <CommonPages class="rankings" headerTheme="dark" titlePrefix="Rank">
    <div class="rankings__container">
      <!-- 移动端Tab切换 -->
      <div class="rankings__tabs" v-if="deviceType === 'mobile'">
        <div class="rankings__tab" :class="{'rankings__tab--active': activeTab === 'release'}"
          @click="activeTab = 'release'">
          New Release Cars
        </div>
        <div class="rankings__tab" :class="{'rankings__tab--active': activeTab === 'fastest'}"
          @click="activeTab = 'fastest'">
          Top Fastest Cars
        </div>
      </div>

      <div class="rankings__columns">
        <!-- 左列 - 新发布车辆 -->
        <div class="rankings__column release"
          v-if="deviceType !== 'mobile' || activeTab === 'release'">
          <div class="rankings__shadow rankings__shadow--release"></div>
          <!-- <div class="rankings__title">NEW RELEASE CARS</div> -->
          <img src="@/assets/release.png" class="rankings__title" alt=""
            v-if="deviceType !== 'mobile'">

          <!-- 加载中提示 -->
          <!-- <div v-if="releaseLoading && releaseRankCars.length === 0" class="rankings__loading">
            <div class="rankings__loading-text">Loading...</div>
          </div> -->

          <div class="rankings__cards">
            <div v-for="(car, index) in releaseRankCars" :key="`new-${index}`"
              class="rankings__card" @click="gotoDetail(car)">
              <!-- 车辆图片 -->
              <div class="rankings__card-image">
                <img :src="car.image" class="rankings__car-img" alt="">
              </div>

              <!-- 车辆信息 -->
              <div class="rankings__card-info">
                <div class="rankings__title-container">
                  <div class="rankings__name">
                    <div class="rankings__model">{{ car.model }}</div>
                    <div class="rankings__brand">{{ car.brand }}</div>
                  </div>
                  <img :src="car.logo" class="rankings__logo" alt="">
                </div>

                <!-- 评分信息 - 移动端显示 -->
                <div class="rankings__rate" v-if="deviceType === 'mobile'">
                  <img src="@/assets/star.svg" class="rankings__rate-icon" alt="">
                  <span class="rankings__rate-label">Rate：</span>
                  <span class="rankings__rate-value">{{ car.rate || '0.0' }}</span>
                  <span class="rankings__rate-max">/10</span>
                </div>

                <div class="rankings__divider" v-if="deviceType !== 'mobile'"></div>

                <div class="rankings__specs" v-if="deviceType !== 'mobile'">
                  <div class="rankings__spec-item">
                    <img src="@/assets/calendar.svg" class="rankings__spec-icon" alt="">
                    <span class="rankings__spec-text">{{ car.year }}</span>
                  </div>
                  <div class="rankings__spec-item">
                    <img src="@/assets/car-type.svg" class="rankings__spec-icon" alt="">
                    <span class="rankings__spec-text">{{ car.category }}</span>
                  </div>
                  <div class="rankings__spec-item">
                    <img src="@/assets/body-type.svg" class="rankings__spec-icon" alt="">
                    <span class="rankings__spec-text">{{ car.bodyType }}</span>
                  </div>
                </div>

                <div class="rankings__divider"></div>

                <div class="rankings__price">
                  <span class="rankings__price-text">{{ car.price }}</span>
                  <div class="rankings__price-link">
                    <img src="@/assets/arrow_outward.svg" class="rankings__arrow" alt="">
                  </div>
                </div>
              </div>
            </div>

            <!-- 加载更多指示器 - 移动端显示 -->
            <div v-if="releaseLoading && deviceType === 'mobile'" class="rankings__loading-more">
              <div class="rankings__loading-text">Loading more...</div>
            </div>
          </div>
        </div>

        <!-- 右列 - 最快车辆 -->
        <div class="rankings__column fastest"
          v-if="deviceType !== 'mobile' || activeTab === 'fastest'">
          <div class="rankings__shadow rankings__shadow--fast"></div>
          <img src="@/assets/fast.png" class="rankings__title" alt=""
            v-if="deviceType !== 'mobile'">

          <!-- 加载中提示 -->
          <!-- <div v-if="fastLoading && fastestRankCars.length === 0" class="rankings__loading">
            <div class="rankings__loading-text">Loading...</div>
          </div> -->

          <div class="rankings__cards">
            <div v-for="(car, index) in fastestRankCars" :key="`fast-${index}`"
              class="rankings__card" @click="gotoDetail(car)">
              <!-- 车辆图片 -->
              <div class="rankings__card-image">
                <img :src="car.image" class="rankings__car-img" alt="">
                <!-- 加速时间 -->
                <div class="rankings__speed">
                  <div class="rankings__speed-value">
                    <div class="rankings__speed-number">{{ car.speedValue }}</div>
                  </div>
                  <div class="rankings__speed-label">
                    <div class="rankings__speed-text">0–60-MPH Times</div>
                  </div>
                </div>
              </div>

              <!-- 车辆信息 -->
              <div class="rankings__card-info">
                <div class="rankings__title-container">
                  <div class="rankings__name">
                    <div class="rankings__model">{{ car.model }}</div>
                    <div class="rankings__brand">{{ car.brand }}</div>
                  </div>
                  <img :src="car.logo" class="rankings__logo" alt="">
                </div>

                <!-- 评分信息 - 移动端显示 -->
                <div class="rankings__rate" v-if="deviceType === 'mobile'">
                  <img src="@/assets/star.svg" class="rankings__rate-icon" alt="">
                  <span class="rankings__rate-label">Rate：</span>
                  <span class="rankings__rate-value">{{ car.rate || '0.0' }}</span>
                  <span class="rankings__rate-max">/10</span>
                </div>

                <div class="rankings__divider" v-if="deviceType !== 'mobile'"></div>

                <div class="rankings__specs" v-if="deviceType !== 'mobile'">
                  <div class="rankings__spec-item">
                    <img src="@/assets/calendar.svg" class="rankings__spec-icon" alt="">
                    <span class="rankings__spec-text">{{ car.year }}</span>
                  </div>
                  <div class="rankings__spec-item">
                    <img src="@/assets/car-type.svg" class="rankings__spec-icon" alt="">
                    <span class="rankings__spec-text">{{ car.category }}</span>
                  </div>
                  <div class="rankings__spec-item">
                    <img src="@/assets/body-type.svg" class="rankings__spec-icon" alt="">
                    <span class="rankings__spec-text">{{ car.bodyType }}</span>
                  </div>
                </div>

                <div class="rankings__divider"></div>

                <div class="rankings__price">
                  <span class="rankings__price-text">{{ car.price }}</span>
                  <div class="rankings__price-link">
                    <img src="@/assets/arrow_outward.svg" class="rankings__arrow" alt="">
                  </div>
                </div>
              </div>
            </div>

            <!-- 加载更多指示器 - 移动端显示 -->
            <div v-if="fastLoading && deviceType === 'mobile'" class="rankings__loading-more">
              <div class="rankings__loading-text">Loading more...</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </CommonPages>
</template>

<script>
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import reportMixin from '@/mixin/reportMixin.js'

export default {
  name: 'Rankings',
  components: {
    CommonPages,
  },
  mixins: [common, adMixin, adTrackingMixin, reportMixin],
  computed: {
    ...mapGetters([
      'deviceType'
    ])
  },
  data () {
    return {
      activeTab: 'release', // 默认显示新发布车辆

      // 新发布榜单数据
      releaseRankCars: [],
      releaseLoading: false,
      releaseError: null,
      releasePageNum: 1,
      releasePageSize: 10,
      releaseHasMore: true,

      // 最快榜单数据
      fastestRankCars: [],
      fastLoading: false,
      fastError: null,
      fastPageNum: 1,
      fastPageSize: 10,
      fastHasMore: true,

    }
  },
  beforeMount () {

  },
  async mounted () {
    // 初始加载数据
    await this.fetchReleaseRank();
    await this.fetchFastRank();
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });

  },
  methods: {
    // 获取新发布车辆排行榜数据
    async fetchReleaseRank () {
      this.releaseLoading = true;
      try {
        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};

        const params = {
          pageNum: this.releasePageNum,
          pageSize: this.releasePageSize,
          ...themeFilters // 添加主题过滤条件
        };

        const res = await this.$global.server.releaseRank(params);

        if (res.code === 200) {
          // 处理API返回数据
          const apiData = res?.data || [];

          if (apiData.length > 0) {
            const processedData = apiData.map(item => this.formatCarData(item));

            // 追加到现有数据
            this.releaseRankCars = [...this.releaseRankCars, ...processedData];

            // 更新分页信息
            this.releasePageNum++;
            this.releaseHasMore = apiData.length >= this.releasePageSize;

            console.log('[Rankings] 获取发布排行榜数据:', processedData.length);
          } else {
            // 没有更多数据
            this.releaseHasMore = false;
            console.log('[Rankings] 发布排行榜没有更多数据');
          }
        } else {
          throw new Error(res.message || 'Failed to get release rank data');
        }
      } catch (error) {
        console.error('[Rankings] 获取发布排行榜数据错误:', error);
        this.releaseError = error.message;
      } finally {
        this.releaseLoading = false;
      }
    },

    // 获取最快车辆排行榜数据
    async fetchFastRank () {
      this.fastLoading = true;
      try {
        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};

        const params = {
          pageNum: this.fastPageNum,
          pageSize: this.fastPageSize,
          ...themeFilters // 添加主题过滤条件
        };

        const res = await this.$global.server.fastRank(params);

        if (res.code === 200) {
          // 处理API返回数据
          const apiData = res?.data || [];

          if (apiData.length > 0) {
            const processedData = apiData.map(item => this.formatCarData(item));

            // 追加到现有数据
            this.fastestRankCars = [...this.fastestRankCars, ...processedData];

            // 更新分页信息
            this.fastPageNum++;
            this.fastHasMore = apiData.length >= this.fastPageSize;

            console.log('[Rankings] 获取最快排行榜数据:', processedData.length);
          } else {
            // 没有更多数据
            this.fastHasMore = false;
            console.log('[Rankings] 最快排行榜没有更多数据');
          }
        } else {
          throw new Error(res.message || 'Failed to get fastest rank data');
        }
      } catch (error) {
        console.error('[Rankings] 获取最快排行榜数据错误:', error);
        this.fastError = error.message;
      } finally {
        this.fastLoading = false;
      }
    },

    // 格式化车辆数据
    formatCarData (item) {
      // 格式化车辆数据以便在页面上显示
      const formattedItem = { ...item };

      // 优先使用接口返回的logo，没有则使用默认logo
      formattedItem.logo = item.logoUrl || require('@/assets/car-logo.svg');

      // // 处理图片
      // if (item.photos) {
      //   // 如果photos是字符串（逗号分隔的URL列表），则转换为数组
      //   if (typeof item.photos === 'string') {
      //     const photoArray = item.photos.split(',');
      //     formattedItem.image = photoArray[0]; // 使用第一张图片作为主图
      //     formattedItem.photos = photoArray; // 保存完整图片数组
      //   } else if (Array.isArray(item.photos) && item.photos.length > 0) {
      //     formattedItem.image = item.photos[0];
      //   } else {
      //     formattedItem.image = require('@/assets/car-recommend-img.png');
      //   }
      // } else if (item.image) {
      //   // 如果已经有image字段，保留
      //   formattedItem.image = item.image;
      // } else {
      //   // 使用默认图片
      //   formattedItem.image = require('@/assets/car-recommend-img.png');
      // }

      formattedItem.image = item.cover;

      // 处理模型名称
      if (!formattedItem.model && item.name) {
        formattedItem.model = item.name;
      }

      // 处理年份
      if (!formattedItem.year && item.marketTime) {
        const match = item.marketTime.match(/(\d{4})/);
        if (match) {
          formattedItem.year = match[1];
        } else {
          formattedItem.year = '-';
        }
      } else if (!formattedItem.year) {
        formattedItem.year = '-';
      }

      // 处理价格显示
      formattedItem.price = this.formatPrice(item.leastPrice, item.mostPrice) ||
        (item.price ? `$${this.formatNumber(item.price)}` : 'Price upon request');

      // 处理加速时间
      if (item.accelerationTime) {
        formattedItem.speedValue = `${item.accelerationTime}s`;
      } else if (formattedItem.speedValue && !formattedItem.speedValue.endsWith('s')) {
        formattedItem.speedValue = `${formattedItem.speedValue}s`;
      } else if (!formattedItem.speedValue) {
        formattedItem.speedValue = '-';
      }

      // 确保category和bodyType有值
      if (!formattedItem.category) {
        formattedItem.category = item.purpose || item.type || 'N/A';
      }

      if (!formattedItem.bodyType) {
        formattedItem.bodyType = item.type || 'N/A';
      }

      // 评分
      if (!formattedItem.rate && item.rate) {
        formattedItem.rate = item.rate;
      } else if (!formattedItem.rate) {
        formattedItem.rate = '0.0';
      }

      return formattedItem;
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `$${this.formatNumber(leastPrice)}-$${this.formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `$${this.formatNumber(leastPrice)}+`;
      } else if (mostPrice) {
        // 只有最高价
        return `<$${this.formatNumber(mostPrice)}`;
      }

      return null;
    },

    // 格式化数字为千分位
    formatNumber (num) {
      if (!num) return '0';
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // 滚动监听（移动端）
    onScroll () {
      // 如果不在移动端，直接返回
      if (this.deviceType !== 'mobile') return;

      const {
        scrollHeight,
        scrollTop,
        clientHeight
      } = document.documentElement;

      // 检查是否接近底部
      if (scrollHeight - scrollTop - clientHeight < this.scrollThreshold) {
        // 根据当前激活的标签加载更多数据
        if (this.activeTab === 'release' && this.releaseHasMore && !this.releaseLoading) {
          this.fetchReleaseRank();
        } else if (this.activeTab === 'fastest' && this.fastHasMore && !this.fastLoading) {
          this.fetchFastRank();
        }
      }
    },

    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },

    // 跳转到车辆详情页面
    gotoDetail (car) {
      try {
        // 检查是否有必要的参数
        if (!car || !car.model) {
          console.warn('[Rankings] Missing car data for detail page');
          return;
        }

        // 获取当前路由的channel参数
        const currentChannel = this.$router.currentRoute.params.channel;

        // 格式化车辆名称，去除空格，用连字符替代
        const formattedName = encodeURIComponent(car.model.replace(/\s+/g, '-'));

        // 如果存在channel参数，则构建带channel的路径
        if (currentChannel) {
          // 获取当前查询参数
          const currentQuery = this.$route.query;
          const queryString = new URLSearchParams(currentQuery).toString();
          const fullQueryString = queryString ? `?${queryString}` : '';

          // 生成完整路径
          const baseUrl = window.location.origin;
          const fullPath = `${baseUrl}/${currentChannel}/cars/${formattedName}/${car.id || '0'}${fullQueryString}`;

          window.location.href = fullPath;
        } else {
          // 不存在channel参数，直接使用router
          // 使用router进行页面跳转
          this.$router.push({
            path: `/cars/${formattedName}/${car.id || '0'}`
          });
        }
      } catch (error) {
        console.error('[Rankings] Detail navigation error:', error);
      }
    },

    // 跳转到所有车辆页面
    gotoAll () {
      // 实现跳转到所有车辆页面的逻辑
      console.log('跳转到所有车辆页面');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.rankings {
	min-height: 100vh;
	background: url('~@/assets/ranking-bg.png') no-repeat center center;
	background-size: 100%;
	position: relative;
	background-position: 0 rem(72);

	&__shadow {
		width: 100%;
		height: rem(330);
		position: absolute;
		top: 0;
		right: 0;
		&--release {
			border-radius: rem(16) rem(16) rem(0) rem(0);
			background: linear-gradient(239deg, rgba(#f7a334, 0.08) 0%, rgba(247, 163, 52, 0) 40.67%);
		}
		&--fast {
			border-radius: rem(16) rem(16) rem(0) rem(0);
			background: linear-gradient(239deg, rgba(#e31837, 0.08) 0%, rgba(227, 24, 55, 0) 40.67%);
		}
	}

	&__container {
		width: 100%;
		padding: rem(40) rem(20);
		max-width: rem(1200);
		margin: 0 auto;
	}

	&__columns {
		display: flex;
		gap: rem(28);
		min-height: 100vh;

		@media (max-width: 768px) {
			flex-direction: column;
		}
	}

	&__column {
		flex: 1;
		width: 100%;
		padding: rem(20);
		border-radius: rem(16);
		background: #fff;
		position: relative;
		&.fastest {
			background: #fff url('~@/assets/flag.png') no-repeat center center;
			background-size: auto rem(115);
			background-position: 100% 0;
		}
	}

	&__title {
		color: #ffffff;

		font-size: rem(24);
		line-height: rem(32);
		font-weight: 700;
		margin-bottom: rem(20);
		height: rem(18);

		@media (max-width: 768px) {
			font-size: rem(20);
			margin-bottom: rem(16);
		}
	}

	&__cards {
		display: flex;
		flex-direction: column;
		gap: rem(10);
	}

	&__card {
		display: flex;
		border-radius: rem(12);
		overflow: hidden;
		transition: all 0.3s ease;
		border: 1px solid #e9e9e9;
		background: #fff;
		position: relative;
		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 rem(10) rem(20) rgba(0, 0, 0, 0.2);
		}
	}

	&__card-image {
		flex: 1;
		position: relative;
		max-width: 50%;
	}

	&__car-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__speed {
		position: absolute;
		top: rem(6);
		left: rem(6);
		z-index: 2;
		display: flex;
		background: rgba(0, 0, 0, 0.5);
		border-radius: rem(8);
		overflow: hidden;
	}

	&__speed-value {
		background: rgba(0, 0, 0, 0.5);
		padding: rem(4) rem(8);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__speed-number {
		color: #ffffff;

		font-size: rem(12);
		line-height: rem(12);
		font-weight: 700;
	}

	&__speed-label {
		padding: rem(4) rem(8);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__speed-text {
		color: #ffffff;

		font-size: rem(10);
		line-height: rem(10);
		font-weight: 400;
	}

	&__card-info {
		flex: 1;
		max-width: 50%;
		padding: rem(14) rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(10);
	}

	&__title-container {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		margin-bottom: rem(10);
	}

	&__name {
		display: flex;
		flex-direction: column;
		gap: rem(8);
	}

	&__logo {
		width: rem(36);
		height: rem(36);
		object-fit: contain;
		background: #fff;
		border-radius: 50%;
		padding: rem(2);
		object-fit: contain;
	}

	&__model {
		color: #050b20;

		font-size: rem(16);
		line-height: rem(16);
		font-weight: 400;
		display: flex;
		align-items: center;
	}

	&__brand {
		color: #848998;

		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		display: flex;
		align-items: center;
	}

	&__divider {
		height: rem(1);
		background: #e9e9e9;
		width: 100%;
	}

	&__specs {
		display: flex;
		flex-direction: column;
		gap: rem(6);
	}

	&__spec-item {
		display: flex;
		align-items: center;
		gap: rem(8);
	}

	&__spec-icon {
		width: rem(14);
		height: rem(14);
	}

	&__spec-text {
		color: #050b20;

		font-size: rem(12);
		line-height: rem(14);
		font-weight: 400;
		display: flex;
		align-items: center;
	}

	&__price {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}

	&__price-text {
		color: #050b20;

		font-size: rem(18);
		line-height: rem(18);
		font-weight: 700;
		display: flex;
		align-items: center;
	}

	&__price-link {
		width: rem(24);
		height: rem(24);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	&__arrow {
		width: rem(16);
		height: rem(16);
	}

	&__tabs {
		display: flex;
		width: 100%;
		height: rem(52);
		margin-bottom: rem(20);
		background-color: #fff;
		border-bottom: 1px solid #e9e9e9;
	}

	&__tab {
		flex: 1;
		padding: rem(12) rem(10);
		text-align: center;

		font-size: rem(16);
		color: #848998;
		cursor: pointer;
		position: relative;
		transition: all 0.3s ease;

		&--active {
			color: #405ff2;
			font-weight: 700;

			&::after {
				content: '';
				position: absolute;
				bottom: -1px;
				left: 0;
				width: 100%;
				height: rem(2);
				background-color: #405ff2;
			}
		}
	}

	&__rate {
		display: flex;
		align-items: center;
		margin-top: rem(10);
		margin-bottom: rem(10);
	}

	&__rate-icon {
		width: rem(16);
		height: rem(16);
		margin-right: rem(8);
	}

	&__rate-label {
		color: #050b20;

		font-size: rem(14);
		margin-right: rem(4);
	}

	&__rate-value {
		color: #405ff2;

		font-size: rem(16);
		font-weight: 700;
	}

	&__rate-max {
		color: #848998;

		font-size: rem(14);
		margin-left: rem(2);
	}

	&__loading,
	&__loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(80);
		width: 100%;
	}

	&__loading {
		height: rem(200);
	}

	&__loading-text {
		font-size: rem(16);
		line-height: rem(24);
		font-weight: 500;
		color: #405ff2;
	}

	&__heading {
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 700;
	}

	&__view {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: rem(20);
	}

	&__view-all {
		font-size: rem(14);
		line-height: rem(14);
	}

	&__icon {
		width: rem(14);
		height: rem(14);
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	&.rankings {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	&.rankings {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		background: #fff;
		// padding: rem(30) rem(16);

		&__container {
			flex-direction: column;
		}

		&__view-all {
			font-size: rem(14);
			line-height: rem(14);
		}

		&__icon {
			width: rem(14);
			height: rem(14);
		}

		&__heading {
			font-size: rem(24);
			line-height: rem(24);
			font-weight: 700;
		}
	}
	.rankings {
		&__columns {
			width: rem(343);
			margin: 0 auto;
		}
		&__container {
			padding: rem(0) rem(0) rem(20);
			background: url('~@/assets/ranking-bg-m.png') no-repeat center center;
			background-size: 100%;
			position: relative;
			background-position: 0 rem(52);
		}

		&__column {
			margin-bottom: rem(0);
			padding: rem(0);
			border-radius: 0;
			background: none;
		}

		&__card {
			flex-direction: column;
			border-bottom: 1px solid #e9e9e9;

			&:last-child {
				margin-bottom: 0;
			}
		}

		&__title-container {
			margin-bottom: 0;
		}
		&__rate {
			margin-top: 0;
			margin-bottom: 0;
		}

		&__card-image {
			max-width: 100%;
			aspect-ratio: 343 / 226;
		}

		&__card-info {
			max-width: 100%;
			gap: rem(16);
			padding: rem(16);
		}

		&__model {
			font-size: rem(18);
			line-height: rem(24);
			font-weight: 700;
		}

		&__brand {
			font-size: rem(14);
			line-height: rem(18);
		}

		&__price {
			justify-content: space-between;
		}

		&__price-text {
			font-size: rem(18);
			line-height: rem(18);
		}

		&__arrow {
			width: rem(16);
			height: rem(16);
		}
	}
}
</style> 